import { Module } from 'vuex'

import { InvoiceStatus, OrderStatus } from '@/models'

import { makeBaseList } from '../models'
import { RootState } from '../state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { OrderingState } from './state'

const namespaced = true

const state: OrderingState = {
  invoices: {
    ...makeBaseList(),
    isDefaultFilters: true,
    query: {
      status: [
        InvoiceStatus.OPEN,
        InvoiceStatus.CLOSING
      ],
      orderBy: 'byDay'
    },
    orders: {},
    orderPayments: {}
  },
  orders: {
    ...makeBaseList(),
    isDefaultFilters: true,
    query: {
      status: [
        OrderStatus.AUTHORIZED,
        OrderStatus.STARTED
      ],
      orderBy: 'byDay'
    }
  },
  orderPayments: {
    ...makeBaseList(),
    isDefaultFilters: true,
    query: {
      applicationType: 1
    }
  }
}

const module: Module<OrderingState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}

export default module
